import {useRewardFreeProducts} from '@/containers/Promotions/components/PromotionsConditions/Rewards/useRewardFreeProducts'
import PromotionSelectionModalV2 from '@/features/Promotions/components/PromotionSelectionModalV2'
import {ProductsDropdown, QuantityDropdown} from '../ConditionFields'

/** v2 "<quantity> <products>" picker for free product rewards. */
export const RewardFreeProducts = ({promotionCondition, index, rewardIndex = 0}) => {
  const {
    isLoadingConfig,
    productTypeOptions,
    buyQtyOptions,
    quantityValue,
    productsValue,
    selectedValuesText,
    isError,
    modalProps,
    modalConditionValues,
    handleBuyCount,
    handleSelectedProductType,
    handleSubmitModal,
    handleCloseModal,
  } = useRewardFreeProducts({promotionCondition, rewardIndex})

  return (
    <div className="flex items-start gap-4">
      <QuantityDropdown
        options={buyQtyOptions}
        value={quantityValue}
        onChange={handleBuyCount}
        isLoading={isLoadingConfig}
        hasError={isError}
      />
      <ProductsDropdown
        options={productTypeOptions}
        value={productsValue}
        selectedText={selectedValuesText}
        onChange={handleSelectedProductType}
        isLoading={isLoadingConfig}
        disabled={index > 0}
      />
      <PromotionSelectionModalV2
        key={JSON.stringify(modalProps.type)}
        show={modalProps.show}
        type={modalProps.type}
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
        conditionValues={modalConditionValues}
      />
    </div>
  )
}
